import { useEffect, useState } from 'react';

/**
 * True once the page has been scrolled past `threshold` pixels.
 * Used to reveal the header only after the hero has been passed.
 */
export const useScrolled = (threshold: number): boolean => {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > threshold);

    handleScroll();
    window.addEventListener('scroll', handleScroll, { passive: true });

    return () => window.removeEventListener('scroll', handleScroll);
  }, [threshold]);

  return scrolled;
};
